import { TemperatureLog } from '../types/temperatureLog';

const API_BASE_URL = import.meta.env.VITE_API_URL || 'http://localhost:3003/api';

const temperatureLogApiService = {
  fetchLogs: async (type: string): Promise<TemperatureLog[]> => {
    try {
      const response = await fetch(`${API_BASE_URL}/temperature-logs?type=${type}`, {
        method: 'GET',
        headers: { 'Content-Type': 'application/json' },
      });

      const data = await response.json();

      if (!data.success) {
        throw new Error(data.error || 'Failed to fetch temperature logs');
      }

      return data.logs;
    } catch (error) {
      console.error('Error fetching temperature logs:', error);
      throw error;
    }
  },

  createLog: async (log: Partial<TemperatureLog>): Promise<TemperatureLog> => {
    try {
      const response = await fetch(`${API_BASE_URL}/temperature-logs`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(log),
      });

      const data = await response.json();

      if (!data.success) {
        throw new Error(data.error || 'Failed to create temperature log');
      }

      return data.log;
    } catch (error) {
      console.error('Error creating temperature log:', error);
      throw error;
    }
  },

  updateLog: async (id: string, log: Partial<TemperatureLog>): Promise<TemperatureLog> => {
    try {
      const response = await fetch(`${API_BASE_URL}/temperature-logs/${id}`, {
        method: 'PUT',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(log),
      });

      const data = await response.json();

      if (!data.success) {
        throw new Error(data.error || 'Failed to update temperature log');
      }

      return data.log;
    } catch (error) {
      console.error('Error updating temperature log:', error);
      throw error;
    }
  },

  deleteLog: async (id: string): Promise<void> => {
    try {
      const response = await fetch(`${API_BASE_URL}/temperature-logs/${id}`, {
        method: 'DELETE',
        headers: { 'Content-Type': 'application/json' },
      });

      const data = await response.json();

      if (!data.success) {
        throw new Error(data.error || 'Failed to delete temperature log');
      }
    } catch (error) {
      console.error('Error deleting temperature log:', error);
      throw error;
    }
  },
};

export default temperatureLogApiService;
